import XLine from './XLine';
import { SOCK_IMAGES, SockColor } from './laundry_game_defs';

interface SockIndicatorProps {
    color: SockColor;
    count: number;
}

function SockIndicator(props: SockIndicatorProps): JSX.Element {
    const { color, count } = props;
    return (
        <div className="sock-indicator">
            <img
                className="sock-image"
                src={SOCK_IMAGES[color]}
                alt={`${SockColor[color]} sock`}
            />
            {count >= 1 && <XLine direction="down" />}
            {count === 2 && <XLine direction="up" />}
        </div>
    );
}

export default SockIndicator;
